module.exports = __webpack_public_path__ + "static/media/arrow-dropdown.c462d4ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/theme/Allianz/images/arrow-dropdown.svg
// module id = 1494
// module chunks = 0